<script lang="ts">
	import type { ApexOptions } from 'apexcharts';
	// Importing ApexCharts to use it as a type breaks the component (window is not defined)
	import type ApexCharts from 'apexcharts';
	import { onMount } from 'svelte';

	interface Props {
		chart: ApexCharts | undefined;
		id: string;
		options: ApexOptions;
		dataCy: string;
		class?: string | undefined;
	}

	let { chart = $bindable(), ...props }: Props = $props();

	let mounted = $state(false);

	onMount(() => {
		setTimeout(() => {
			const renderChart = async () => {
				const element = document.querySelector<HTMLElement>(`#${props.id}`);
				if (!element) return;

				const ApexCharts = (await import('apexcharts')).default;
				chart = new ApexCharts(element, props.options);
				chart.render().then(() => {
					mounted = true;
				});
			};

			renderChart();
		}, 50);
	});

	$effect(() => {
		if (mounted && chart) {
			chart.updateOptions(props.options);
		}
	});
</script>

<div id={props.id} data-cy={`${props.dataCy}-chart`} class={props.class}></div>
